import {Component, Input, OnInit} from '@angular/core';
import {IDocument} from "../../interfaces/document.definition";
import {WatchService} from "../../services/watch.service";
import {paramsHelper} from "../../helpers/params-helper";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {GO_CATEGORIES} from "../../enums/e-game-objects";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {CollectionService} from "../../services/collection.service";

@Component({
  selector: 'nv-resources-list',
  templateUrl: './nv-resources-list.component.html',
  styles: []
})
export class NvResourcesListComponent implements OnInit {

  @Input() showAddButton = true;
  @Input() showRemoveButton = true;
  @Input() document:IDocument;
  @Input() prop: string;
  _label: string;
  @Input() set label(v: string) {
    this._label = v;
  }

  get label(): string {
    return this._label || this.prop;
  }

  resourcesList:IDocument[] = [];
  currentRes:any = {id:0};

  constructor(private watchService:WatchService,
              private collectionService:CollectionService) { }

  ngOnInit() {
    this.loadResourcesList();
  }

  addItem(){
    if (typeof this.document[this.prop] === "undefined") {
      this.document[this.prop] = [];
    }
    this.document[this.prop].push(this.currentRes.id);
    this.watchService.notify();
  }

  removeItem(index: number) {
    let c = this.document[this.prop];
    c.splice(index, 1);
    this.watchService.notify();
  }

  private  loadResourcesList(){
    const search = paramsHelper
      .search()
      .addParam("category", SEARCH_PROP_TYPES.ENUM_MULTI, [GO_CATEGORIES.STUFF])
      .json;

    const params = paramsHelper
      .loader()
      .setEndpointApi()
      .setObjectType(DOCUMENT_TYPES.GO)
      .setNavParams(0, 9999)
      .setSearchParams(search);

    this.collectionService.loadChunkCached(params)
      .subscribe(
        r => {
          this.resourcesList = r.documents;
        });
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-resources-list/nv-resources-list.component.ts